import React from "react";
import dummyImage from "../../front_assets/user_images/dummy.jpg";
import "../../CSS/Navbar.css";
import AuthUser from "../AuthUser";
import { cashierLang } from "../language/pages/cashierPageLang";
import useLanguage from "../language/useLanguage";

export default function CashierNavbar() {
  const lan = useLanguage(cashierLang);
  const { token, logout, user } = AuthUser();
  const userLogout = () => {
    if (token != undefined) {
      logout();
    }
  };

  return (
    <div className="custom_navbar">
      <nav className="navbar">
        <a href="#" className="sidebar-toggler">
          <i data-feather="menu" />
        </a>
        <div className="navbar-content">
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="profileDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {user.user_image ? (
                  <>
                    <img
                      className="wd-30 ht-30 rounded-circle"
                      src={user.user_image}
                      alt="profile"
                    />
                  </>
                ) : (
                  <>
                    <img
                      className="wd-30 ht-30 rounded-circle"
                      src={dummyImage}
                      alt="profile"
                    />
                  </>
                )}
              </a>
              <div
                className="dropdown-menu p-0"
                aria-labelledby="profileDropdown"
              >
                <div className="d-flex flex-column align-items-center border-bottom px-5 py-3">
                  <div className="mb-3">
                    {user.user_image ? (
                      <>
                        <img
                          className="wd-80 ht-80 rounded-circle"
                          src={user.user_image}
                          alt="profile"
                        />
                      </>
                    ) : (
                      <>
                        <img
                          className="wd-80 ht-80 rounded-circle"
                          src={dummyImage}
                          alt="profile"
                        />
                      </>
                    )}
                  </div>
                  <div className="text-center">
                    <p className="tx-16 fw-bolder">{user?.name}</p>
                    <p className="tx-12 text-muted">{user?.email}</p>
                  </div>
                </div>
                <ul className="list-unstyled p-1">
                  <li
                    onClick={userLogout}
                    style={{ cursor: "pointer" }}
                    className="dropdown-item py-2"
                  >
                    <a className="text-body ms-0">
                      <i className="me-2 icon-md" data-feather="log-out" />
                      <span>{lan?.logOut}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
